import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import {IBaseResponse} from "./IBaseResponse";

enum TradeServiceEnum {
  phaseApproveProjeto300 = "/approve-projeto300",
  approveTradePhaseEnum = "/approve?idTrade=",
  phaseApprove = "/approve"
}

export default class TradePhaseService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/trade/phase");
  }

  public approveProjeto300 = async data => await this.PUT(TradeServiceEnum.phaseApproveProjeto300, data);

  public putApproveTradePhase = async (idTrade: number): Promise<IBaseResponse> => await this.PUT(TradeServiceEnum.approveTradePhaseEnum + idTrade, null);

  //#region refatoração de trades
  // phase or status empty return all trades
  public putInPhaseApprove = async data => await this.PUT(TradeServiceEnum.phaseApprove, data);

  //#endregion
}



// WEBPACK FOOTER //
// ./src/services/api/TradePhase.service.ts